import { TagType } from 'rs-emd-ui-atoms';

//keys are the text size and values are the tag type
export const TextTagTypeConvertor: { [id: string]: TagType } = {
  xxl: 'h1',
  xl: 'h2',
  lg: 'h3',
  md: 'h4',
  sm: 'h5',
  paragraph: 'p',
  label: 'p',
};
